import axios from "axios";

/**
 * Codes d'erreur métier renvoyés par l'API Laravel dans la clé `code` de la réponse.
 * Ils doivent rester alignés sur les constantes PHP côté back.
 */
export const CODE_SIRET_MANQUANT = "SIRET_MANQUANT";

/**
 * Récupère le code d'erreur métier d'une erreur axios.
 *
 * Les téléchargements de PDF utilisent `responseType: "arraybuffer"`, ce qui s'applique
 * aussi aux réponses d'erreur : le corps JSON arrive alors sous forme d'ArrayBuffer et
 * doit être décodé avant d'être lu.
 */
export const getCodeErreurMetier = (error: unknown): string | undefined => {
  if (!axios.isAxiosError(error)) return undefined;

  const data = error.response?.data;
  if (!data) return undefined;

  if (data instanceof ArrayBuffer) {
    try {
      const { code } = JSON.parse(new TextDecoder().decode(data));
      return typeof code === "string" ? code : undefined;
    } catch {
      return undefined;
    }
  }

  if (typeof data === "object" && "code" in data && typeof data.code === "string") {
    return data.code;
  }

  return undefined;
};
